import "./Homepage.css";
import "./contact-us.css";
import Enqiry from "./Enqiry";
import Aboutussec from "./image/contactus-img.png";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
// import axios from "axios";
import Modal from "react-bootstrap/Modal";
function Contact() {
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [add, setadd] = useState("");
  const [Msg, setMsg] = useState("");
  const [Variant, setVariant] = useState("");
  // const [data, setdata] = useState("");
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    handleShow();
  }, [pathname]);

  // function Submitform(e) {
  // e.preventDefault();

  // if (name === "") {
  //   setVariant("danger");
  //   setMsg("name is required");
  // }
  // if (email === "") {
  //   setVariant("danger");
  //   setMsg("email is required");
  // }
  // if (number === "") {
  //   setVariant("danger");
  //   setMsg("phone no is required");
  // }
  // if (add === "") {
  //   setVariant("danger");
  //   setMsg("Addres is required");
  // }
  // if (name !== "" && email !== "" && number !== "" && add !== "") {
  //   setVariant("success");
  //   setMsg("Submitted Successfully.");
  //   api();
  // }
  // }
  // const api = async () => {
  //   const res = await axios.post("http://localhost:8001/api/v1/auth/register", {
  //     username: name,
  //     email: email,
  //     phone: number,
  //     address: add,
  //   });

  //   console.log(res.data);
  // };
  function Submit(e) {
    const formEle = document.getElementById("form");
    const formDatab = new FormData(formEle);

    e.preventDefault();

    if (name === "") {
      setVariant("danger");
      setMsg("name is required");
    }
    if (email === "") {
      setVariant("danger");
      setMsg("email is required");
    }
    if (number === "") {
      setVariant("danger");
      setMsg("phone no is required");
    }
    if (add === "") {
      setVariant("danger");
      setMsg("Addres is required");
    }
    if (name !== "" && email !== "" && number !== "" && add !== "") {
      fetch(
        "https://script.google.com/macros/s/AKfycbwGu77bf09MBHyjC5Rk-cCu8UhqWeOsod_3xiyiNxb-urIVu9el2rlJwvy4dx4AmD61FA/exec",
        {
          method: "POST",
          body: formDatab,
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log(error);
        });
      setVariant("success");
      setMsg("Submitted Successfully.");
    }
  }
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Get a quotes</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "100%" }}>
          <form id="form" onSubmit={(e) => Submit(e)}>
            <input
              className="inp_text"
              type="text"
              placeholder="Enter Your Name*"
              name="Name"
              onChange={(e) => {
                setname(e.target.value);
              }}
            />
            <input
              className="inp_text"
              type="text"
              placeholder="Enter Your Email*"
              name="Email"
              onChange={(e) => {
                setemail(e.target.value);
              }}
            />
            <input
              className="inp_text"
              type="number"
              placeholder="Enter Your Phone no.*"
              name="Phone_no"
              onChange={(e) => {
                setnumber(e.target.value);
              }}
            />

            <textarea
              className="text_form"
              rows="2"
              placeholder="Enter Your Full Address*"
              name="Address"
              onChange={(e) => {
                setadd(e.target.value);
              }}
            ></textarea>
            {Msg !== "" ? (
              <Alert variant={Variant} style={{ marginTop: "15px" }}>
                {Msg}
              </Alert>
            ) : (
              ""
            )}
            <button
              style={{
                padding: 5,
                borderRadius: 5,
                border: "none",
                color: "#fff",
                backgroundColor: "red",
              }}
              type="Submit"
            >
              Submit
            </button>
          </form>
        </Modal.Body>
      </Modal>
      <img width="100%" src={Aboutussec} className="img-fluid" alt="..." />
      <Enqiry />
    </>
  );
}
export default Contact;
